import { useSyncExternalStore } from "react";
import type { SessionSnapshot, SessionStore } from "./session-store";

/** The current session as React state; re-renders on every auth change. */
export function useSession(store: SessionStore): SessionSnapshot {
  return useSyncExternalStore(store.subscribe, store.getSnapshot, store.getSnapshot);
}
